import { render, staticRenderFns } from "./remarkDialog.vue?vue&type=template&id=0f6b0a60&scoped=true"
import script from "./remarkDialog.vue?vue&type=script&lang=js"
export * from "./remarkDialog.vue?vue&type=script&lang=js"
import style0 from "./remarkDialog.vue?vue&type=style&index=0&id=0f6b0a60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6b0a60",
  null
  
)

export default component.exports